export type THighlightPosition = { start: number; length: number }

export type THighlightSegment = { text: string; isHighlighted: boolean }

export const getHighlightSegments = (
  value: string | null | undefined,
  searchString: string,
  highlightPositions: THighlightPosition[] | undefined,
): THighlightSegment[] => {
  if (!value) return []
  if (!highlightPositions || highlightPositions.length === 0) return [{ text: value, isHighlighted: false }]

  const lowercaseSearchString = searchString.toLowerCase()
  const sortedPositions = [...highlightPositions].sort(
    (positionA, positionB) => positionA.start - positionB.start,
  )
  const segments: THighlightSegment[] = []
  let lastIndex = 0

  for (const { start, length } of sortedPositions) {
    segments.push({ text: value.slice(lastIndex, start), isHighlighted: false })

    const matchedSubString = value.slice(start, start + length)
    segments.push({
      text: matchedSubString,
      isHighlighted: lowercaseSearchString.includes(matchedSubString.toLowerCase()),
    })

    lastIndex = start + length
  }
  segments.push({ text: value.slice(lastIndex), isHighlighted: false })

  return segments.filter((segment) => segment.text !== '')
}

// The match positions are computed on the ISO date (YYYY-MM-DD) but the date is displayed as DD/MM/YYYY
export const getBirthdateHighlightSegments = (
  isoBirthdate: string | null | undefined,
  searchString: string,
  highlightPositions: THighlightPosition[] | undefined,
): THighlightSegment[] => {
  const dateParts: THighlightSegment[][] = [[]]

  for (const segment of getHighlightSegments(isoBirthdate, searchString, highlightPositions)) {
    const [firstPart, ...nextParts] = segment.text.split('-')
    dateParts.at(-1)?.push({ ...segment, text: firstPart })
    for (const nextPart of nextParts) dateParts.push([{ ...segment, text: nextPart }])
  }

  return dateParts
    .reverse()
    .flatMap((datePart, index) => [
      ...(index === 0 ? [] : [{ text: '/', isHighlighted: false }]),
      ...datePart.filter((segment) => segment.text !== ''),
    ])
}
